<ng-container *ngTemplateOutlet="mode() === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('md') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="homefilterdesk"></ng-container>
    }
    }
</ng-template>

<ng-template #nohomefilter>
    @if(mode() === 'nohomesmall') {
    {{(zielText()) + ' ' + (ziel())}}
    } @else {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
</ng-template>


<ng-template #homemodeMobile>
    <div class="searchBoxWrapper_mobile customflex" #mdbuttondesk="cdkOverlayOrigin"
        [class.searchBoxWrapperactive]="showModal()" cdkOverlayOrigin (click)="openModal()" ng-clickOutside
        (clickOutside)="closeModal()">
        <div class="wrapper">
            <span class="description">{{ziel()}}</span>
            <div class="searchinputwrapper">
                <input type="text" placeholder="{{showModal() ? '': zielText()}}" [class.inputactive]="showModal()"
                    [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus()" class="searchinput">
                @if(mySearchControl?.value?.length > 0) {
                <button (click)="clearText()" class="closesection">
                    <img src="../../../../assets/tvg/close.svg" alt="close">
                </button>
                }
            </div>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>
</ng-template>

<ng-template #homefilterdesk>
    <!-- <button class="tmpbtn tmpnorightborder w100" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModal($event)" matRipple>
        <svg class="rotate" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
            fill="#000000">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
                d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
        </svg>
        <span>{{zielText}}</span>
    </button> -->
    <div class="searchBoxWrapper" #mdbuttondesk="cdkOverlayOrigin" [class.searchBoxWrapperactive]="showModal()"
        cdkOverlayOrigin (click)="openModal()" ng-clickOutside (clickOutside)="closeModal()">
        <div class="wrapper">
            <span class="description">{{ziel()}}</span>
            <div class="searchinputwrapper">
                <input type="text" placeholder="{{showModal() ? '': zielText()}}" [class.inputactive]="showModal()"
                    [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus()" class="searchinput">
                @if(mySearchControl?.value?.length > 0) {
                <button (click)="clearText()" class="closesection">
                    <img src="../../../../assets/tvg/close.svg" alt="close">
                </button>
                }
            </div>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>
</ng-template>


<ng-template #modal>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="modeDesk"></ng-container>
    }
    }
</ng-template>


<ng-template #modeDesk>
    <div class="custompopupwrapper mat-elevation-z1">
        <div class="popupbody">
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile">
        <div class="filterwrapper-mobile">
            <button class="shettheader" (click)="closeModalMobile()" #searchheader>
                <img src="../../../../../assets/tvg/leftdirection.svg" alt="goback icon">
                <span>Wo fliegen Sie los?</span>
            </button>
            <div class="searchBoxWrapper customflex" #mdbuttondesk="cdkOverlayOrigin"
                [class.searchBoxWrapperactive]="showModal()" cdkOverlayOrigin (click)="openModal()" ng-clickOutside
                (clickOutside)="closeModal()">
                <div class="wrapper" (click)="$event.stopPropagation()">
                    <span class="description">{{ziel()}}</span>
                    <div class="searchinputwrapper">
                        <input type="text" placeholder="{{showModal() ? '': zielText()}}"
                            [class.inputactive]="showModal()" [formControl]="mySearchControl" ng-focus
                            [appAutoFocus]="focus()" class="searchinput">
                        @if(mySearchControl?.value?.length > 0) {
                        <button (click)="clearText()" class="closesection">
                            <img src="../../../../assets/tvg/close.svg" alt="close">
                        </button>
                        }
                    </div>
                </div>
            </div>
            <div class="custompopupwrapper-mobile">
                <div class="popupbody">
                    <ng-container *ngTemplateOutlet="datassection"></ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="resultatwrapper customscroll" (click)="$event.stopPropagation()">
        @if(selectedList()?.length > 0) {
        <div class="selected-wrapper">
            <button class="selected-item-alle" (click)="removeAllSelected($event)">
                <span>{{'Alles löschen'}}</span>
            </button>
            @for (item of selectedList(); let k = $index; track k) {
            <div class="selected-item">
                <span>{{item.name}} <span class="second-item-line">{{item.code}}</span></span>
                <button (click)="removeFromSelected($event, k)">
                    <mat-icon class="clearbtn">clear</mat-icon>
                </button>
            </div>
            }
        </div>
        }
        @if(mySearchControl?.value?.length > 0 && (searchObj | async); as airports) {
        @for (item of airports; track $index) {
        @if(isNotInlist(item)) {
        <button class="item-wrapper" (click)="selectAir($event, item)">
            <div class="item-body">
                <span class="first-item-line">{{item.name}} <span class="second-item-line">{{item.code}}</span></span>
            </div>
        </button>
        }
        }
        } @else {
        <div class="customchipwrapper">
            @if(selectedList()?.length > 0) {
            <button class="custopmchip" (click)="removeAllSelected($event)">
                <span>beliebig</span>
            </button>
            } @else {
            <button class="custopmchip_active" (click)="removeAllSelected($event)">
                <img src="../../../../assets/tvg/checked.svg" alt="checked">
                <span>beliebig</span>
            </button>
            }
        </div>
        <div class="searchresbody">
            <div class="titlewrp">
                <span class="stattitle">Beliebte Flughäfen</span>
            </div>
            <div class="customchipwrapper">
                @for (item of beliebig_flughafen; track $index) {
                @if(isNotInlist(item)) {
                <button class="custopmchip" (click)="addAirport($event, item)">
                    <span>{{item.name}} ({{item.code}})</span>
                </button>
                } @else {
                <button class="custopmchip_active" (click)="addAirport($event, item)">
                    <img src="../../../../assets/tvg/checked.svg" alt="checked">
                    <span>{{item.name}} ({{item.code}})</span>
                </button>
                }
                }

            </div>
        </div>
        <div class="searchresbody">
            <div class="titlewrp">
                <span class="stattitle">Region</span>
            </div>
            <div class="regionwrapper">
                <button class="cc5" (click)="checkNord($event)">
                    @if(flughafen_nord() === 1) {
                    <img src="../../../../assets/tvg/checkboxactive.svg" alt="checkbox">
                    } @else if(flughafen_nord() === -1) {
                    <img src="../../../../assets/tvg/checkbox.svg" alt="checkbox">
                    } @else {
                    <img src="../../../../assets/tvg/nocompletchecked.svg" alt="checkbox">
                    }
                    <span class="cc6">Nord</span>
                </button>
                <button class="cc5" (click)="checkOst($event)">
                    @if(flughafen_ost() === 1) {
                    <img src="../../../../assets/tvg/checkboxactive.svg" alt="checkbox">
                    } @else if(flughafen_ost() === -1) {
                    <img src="../../../../assets/tvg/checkbox.svg" alt="checkbox">
                    } @else {
                    <img src="../../../../assets/tvg/nocompletchecked.svg" alt="checkbox">
                    }
                    <span class="cc6">Ost</span>
                </button>
                <button class="cc5" (click)="checkSud($event)">
                    @if(flughafen_sud() === 1) {
                    <img src="../../../../assets/tvg/checkboxactive.svg" alt="checkbox">
                    } @else if(flughafen_sud() === -1) {
                    <img src="../../../../assets/tvg/checkbox.svg" alt="checkbox">
                    } @else {
                    <img src="../../../../assets/tvg/nocompletchecked.svg" alt="checkbox">
                    }
                    <span class="cc6">Süd</span>
                </button>
                <button class="cc5" (click)="checkWest($event)">
                    @if(flughafen_west() === 1) {
                    <img src="../../../../assets/tvg/checkboxactive.svg" alt="checkbox">
                    } @else if(flughafen_west() === -1) {
                    <img src="../../../../assets/tvg/checkbox.svg" alt="checkbox">
                    } @else {
                    <img src="../../../../assets/tvg/nocompletchecked.svg" alt="checkbox">
                    }
                    <span class="cc6">West</span>
                </button>
            </div>
        </div>
        <div class="searchresbody">
            <div class="titlewrp">
                <span class="stattitle">Deutschland</span>
            </div>
            <div class="cc4">
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: de_flughafen}"></ng-container>
            </div>
        </div>

        <div class="searchresbody">
            <div class="titlewrp">
                <span class="stattitle">Europäische Abflughäfen</span>
            </div>
            <div class="cc4">
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: fr_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: es_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: at_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: ch_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: lu_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: be_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: nl_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: pl_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: dk_flughafen}"></ng-container>
                <ng-container *ngTemplateOutlet="statairplist context:{airlist: cz_flughafen}"></ng-container>
            </div>
        </div>
        }
    </div>
    <div class="ubwrapper">
        <button class="custombutton customblue_unfilled w50" (click)="removeAllSelected($event)">Auswahl
            aufheben</button>
        <button class="custombutton customunfilled w50" (click)="take()">Übernehmen {{selectedList()?.length > 0 ? '(' +
            selectedList().length + ')' : ''}}</button>
    </div>
</ng-template>

<ng-template #ckbb>
    <mat-icon class="cc_ico">check_box</mat-icon>
</ng-template>

<ng-template #statairplist let-airlist="airlist">
    @for (flg of airlist; track $index) {
    <button class="cc5" (click)="addAirport($event, flg)">
        @if(isNotInlist(flg)) {
        <img src="../../../../assets/tvg/checkbox.svg" alt="checkbox">
        } @else {
        <img src="../../../../assets/tvg/checkboxactive.svg" alt="checkbox active">
        }
        <span class="cc6">{{flg.name}} ({{flg.code}})</span>
    </button>
    }
</ng-template>